<style src="./BidCapture.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="bid-capture">
    <form @submit.prevent="submitForm" class="row">
      <suggest-client
        label="Cliente"
        class="col-12"
        placeholder="Marinha do brasil"
        @selected="selectedClient"
        v-model="client"/>

      <textbox
        class="col-6"
        label="Código"
        placeholder="19856"
        v-model="form.alternativeCode" />
        
      <textbox
        class="col-6"
        :autofocus="true"
        label="Identificador *"
        placeholder="PP 205"
        v-model="form.identification" />

      <dropdown
        label="Modalidade *"
        placeholder="Escolha..."
        v-model="form.modality"
        class="col-12"
        :list-data="listModality"/>

      <dropdown
        label="Objeto *"
        placeholder="Escolha..."
        v-model="form.eventObject"
        class="col-12"
        :list-data="listEventObject"/>

      <moneybox
        class="col-6"
        label="Estimado (R$)"
        placeholder="1.250.000,00"
        v-model="form.estimated" />

      <textbox
        class="col-6"
        label="Quantidade Itens"
        placeholder="230"
        v-model="form.countItems" />

      <textbox
        class="col-12"
        label="Website / Representante"
        placeholder="www.comprasnet.com ou José Antonio"
        v-model="form.sourcePortal" />

      <div class="col-12">
        <div class="row no-side-margin between-all">
          <datebox
            class="col-6"
            label="Data do evento *"
            placeholder="05/01/2078"
            v-model="eventPeriod.date" />

          <timebox
            class="col-6"
            label="Hora do evento *"
            placeholder="15:00:00"
            v-model="eventPeriod.time" />
        </div>
      </div>

      <div class="col-12">
        <div class="row no-side-margin between-all">
          <datebox
            class="col-6"
            label="Data de entrega *"
            placeholder="03/01/2078"
            v-model="eventPeriod.deadlineDate" />

          <timebox
            class="col-6"
            label="Hora do evento *"
            placeholder="13:00:00"
            v-model="eventPeriod.deadlineTime" />
        </div>
      </div>

      <section class="col-12">
        <div
          class="inserted-file"
          v-show="uploadStage === 'INSERTED'">
          <icon-check class="icon"/>
          <h3>Arquivo anexado!</h3>
          <h5>Seu arquivo foi anexado. Clique em SALVAR EVENTO para envia-lo ao nosso servidor</h5>
        </div>
      </section>
      <div class="commands col-12">
        <cp1-button-submit
          class="submit"
          label="Salvar Evento"
          :icon-save="commands.saveIcon"/>
      </div>
    </form>
  </section>
</template>

<script>
import SaveNewEvent from './SaveNewEvent'
import UpdateEvent from './UpdateEvent'
import { Textbox, ButtonSubmit, Dropdown, Datebox, Timebox, SuggestClient, Moneybox } from '@/components/primitives'
import { IconWait, IconUpload, IconSave, IconClose, IconCheck } from '@/components/primitives/icons'
import moment from 'moment'

let attachFile = null

export default {
  name: 'BidCapture',
  components: {
    IconWait,
    IconUpload,
    IconCheck,
    Textbox,
    Moneybox,
    Dropdown,
    Datebox,
    Timebox,
    ButtonSubmit,
    IconSave,
    IconClose,
    SuggestClient
  },
  props: {
    eventId: null
  },
  data () {
    return {
      dragOverClass: false,
      uploadStage: 'UPLOAD',
      eventPeriod: {
        date: '',
        time: '',
        deadlineDate: '',
        deadlineTime: ''
      },
      form: {
        countItems: 0,
        estimated: 0,
        client: '',
        alternativeCode: '',
        identification: '',
        eventObject: '',
        modality: '',
        sourcePortal: ''
      },
      client: null,
      commands: {
        submitState: 'REPOSE',
        saveIcon: IconSave
      },
      listModality: [],
      listEventObject: [
        { text: 'MEDICAMENTO', value: 'MEDICAMENTO' },
        { text: 'MATERIAL HOSPITALAR', value: 'MATERIAL HOSPITALAR' },
        { text: 'LABORATÓRIO', value: 'LABORATÓRIO' },
        { text: 'MATERIAL ODONTOLÓGICO', value: 'MATERIAL ODONTOLÓGICO' },
        { text: 'EQUIPAMENTO HOPITALAR', value: 'EQUIPAMENTO HOPITALAR' },
        { text: 'EQUIPAMENTO ODONTOLÓGICO', value: 'EQUIPAMENTO ODONTOLÓGICO' }
      ]
    }
  },
  mounted () {
    this.loadModalities()
    this.loadEventDetails()
  },
  methods: {
    loadModalities () {
      const modalities = this.$store.getters['Events/GET_MODALITIES']
      this.listModality = modalities
    },
    async createNewEvent () {
      try {
        // if (this.dragOverClass) this.dragOverClass = false
        this.uploadStage = 'WAIT'

        const dateEventRaw = `${this.eventPeriod.date} ${this.eventPeriod.time || '12:00:00'}`
        const dateDeadlineRaw = `${this.eventPeriod.deadlineDate} ${this.eventPeriod.deadlineTime || '12:00:00'}`
        const form = { ...this.form }

        delete form.dateEvent
        delete form.dateDeadline

        if (this.form.modality.value) {
          form.modality = this.form.modality.value
        }
        if (this.form.eventObject.value) {
          form.eventObject = this.form.eventObject.value
        }

        const dateEvent = moment(dateEventRaw, 'DD/MM/YYYY HH:mm:ss')
        if (dateEvent.isValid()) {
          form.dateEvent = dateEvent.toDate()
        }

        const dateDeadline = moment(dateDeadlineRaw, 'DD/MM/YYYY HH:mm:ss')
        if (dateDeadline.isValid()) {
          form.dateDeadline = dateDeadline.toDate()
        }
        if (form.estimated.toString() === '0,00') {
          form.estimated = 0
        } else {
          form.estimated = form.estimated.toString().replace(/\./g, '').replace(',', '.')
        }

        if (this.eventId) {
          await UpdateEvent({
            eventId: this.eventId,
            form
          })
          this.$toasted.success('Evento salvo com sucesso')
        } else {
          await SaveNewEvent({ file: attachFile, form })
          this.$toasted.success('Evento salvo com sucesso')
          this.clearForm()
          this.closePanel()
        }
      } catch (error) {
        this.$toasted.error('Não foi possível savar o evento')
      } finally {
        // this.uploadStage = 'UPLOAD'
      }
    },
    submitForm () {
      this.createNewEvent()
    },
    clearForm () {
      attachFile = null
      const form = {
        client: '',
        alternativeCode: '',
        date: {
          created: '',
          deadline: '',
          event: ''
        },
        identification: '',
        participate: true,
        status: 0,
        countItems: 0,
        estimated: 0,
        eventObject: '',
        modality: '',
        sourcePortal: ''
      }
      const eventPeriod = {
        date: '',
        time: '',
        deadlineDate: '',
        deadlineTime: ''
      }

      this.eventPeriod = eventPeriod
      this.form = form
    },
    closePanel () {
      this.$emit('close-panel')
    },
    orderClientList: (pList) => {
      const r = Object.values(pList).sort((a, b) => {
        return b.shortName.trim() - a.shortName.trim()
      })
      return r
    },
    selectedClient (pItem) {
      this.form.client = pItem.source._id
    },
    async loadEventDetails () {
      if (!this.eventId) {
        return
      }
      const eventInfo = await this.$store.dispatch('Board/GET_EVENT_DETAILS', {
        eventId: this.eventId
      })
      if (!eventInfo) return false
      this.client = eventInfo.client && eventInfo.client.shortName
      this.form.client = eventInfo.client && eventInfo.client._id
      this.form.alternativeCode = eventInfo.alternativeCode || ''
      this.form.identification = eventInfo.identification || ''
      this.form.modality = eventInfo.modality || ''
      this.form.eventObject = eventInfo.eventObject || ''
      this.form.estimated = (eventInfo.estimated && eventInfo.estimated.toFixed(2)) || 0
      this.form.countItems = eventInfo.countItems || 0
      this.form.sourcePortal = eventInfo.sourcePortal || 0
      this.eventPeriod.date = this.extractDate(eventInfo.date && eventInfo.date.event)
      this.eventPeriod.time = this.extractTime(eventInfo.date && eventInfo.date.event)
      this.eventPeriod.deadlineDate = this.extractDate(eventInfo.date && eventInfo.date.deadline)
      this.eventPeriod.deadlineTime = this.extractTime(eventInfo.date && eventInfo.date.deadline)
    },
    extractDate (dt) {
      if (dt) {
        return moment(dt).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    extractTime (dt) {
      if (dt) {
        return moment(dt).format('HH:mm:ss')
      } else {
        return ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/event/bid-capture/BidCapture.vue